// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5662":"12ff0067","5811":"fb0e154f","8745":"dd132165","9276":"d2c28701"}[chunkId] + ".chunk.css";
};